import { Expose } from 'class-transformer';
import type { IRepayOrder } from './repayment.interface';

export class RepaymentModel {
  // 所有可还款金额 = 逾期部分总金额 + DOB 10+部分总金额
  @Expose()
  total_amount!: number;

  @Expose()
  overflow_amount!: number;

  @Expose()
  overdueInfo!: IRepayOrder;

  @Expose()
  repayableInfo!: IRepayOrder;

  @Expose()
  selectedChannelName!: string;

  @Expose()
  selectedChannelId!: number;

  @Expose()
  payOption!: string;

  @Expose()
  loading!: boolean;

  // 可还款订单数超出后端 large_order_count_threshold，需引导用户优先只还逾期
  @Expose()
  is_large_order_volume!: boolean;
}
